import React, { FC } from "react";
import Radio from "../../radio";

const ChooseCard: FC<{
  editCardInfo: boolean;
  onChange: (val: boolean) => void;
}> = ({ editCardInfo, onChange }) => (
  <div className="row mt-3 radio-buttons-wrapper">
    <div className="col-12 col-sm-6 text-center d-flex justify-content-center">
      <Radio
        checked={!editCardInfo}
        border
        onClick={() => editCardInfo && onChange(false)}
      />
      <div
        className="radio-label"
        onClick={() => editCardInfo && onChange(false)}
      >
        Use my last payment method
      </div>
    </div>
    <div className="col-12 col-sm-6 text-center d-flex justify-content-center">
      <Radio
        checked={editCardInfo}
        border
        onClick={() => !editCardInfo && onChange(true)}
      />
      <div
        className="radio-label"
        onClick={() => !editCardInfo && onChange(true)}
      >
        Add new payment method
      </div>
    </div>
  </div>
);

export default ChooseCard;
